export default [
    {
        label: "Clients",
        icon: "user",
        settingsKey: "projectClients",
        tableSettings: {
            route: "projectclients",
            formType: "popup",
            showItemPerPageOption: true,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myProjectclients",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true, 
        },
    },
    {
        label: "Upload Joint's Excel File",
        icon: "user",
        settingsKey: "Joints",
        tableSettings: {
            route: "projectjoints",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myProjectjoints",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: false, 
        },
    },
    {
        label: "Joint List",
        icon: "user",
        settingsKey: "Joints",
        tableSettings: {
            route: "rawjoinlists",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myProjectjointsList",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: false, 
        },
    },
    
] 